import React, { useEffect, useState } from 'react';
import { API } from '../api';
import Button from '../ui/Button';
import { Spinner } from '../ui/Loading';

const OAuthPage = () => {
  const [oauthUrl, setOauthUrl] = useState('');
  const [loading, setLoading] = useState(true);
  const [failed, setFailed] = useState(false);
  const [attempt, setAttempt] = useState(0);

  // The backend hands out the Google sign-in URL.
  useEffect(() => {
    let live = true;
    setLoading(true);
    setFailed(false);
    API.GET_OAUTH().then(
      (response) => {
        if (!live) return;
        setOauthUrl(response?.url || '');
        setFailed(!response?.url);
        setLoading(false);
      },
      () => {
        if (!live) return;
        setFailed(true);
        setLoading(false);
      },
    );
    return () => {
      live = false;
    };
  }, [attempt]);

  return (
    <main className="h-full overflow-y-auto bg-paper flex items-center px-8 py-16">
      <div className="w-full max-w-[400px] mx-auto">
        <div className="grid grid-cols-[6px_minmax(0,1fr)] gap-x-4">
          <div className="rounded-badge bg-signal" aria-hidden="true" />
          <div className="min-w-0">
            <p className="font-mono text-entity tracking-[-0.01em] text-ink">
              SecOps<span className="font-normal text-graphite"> SBOM</span>
            </p>
            <p className="mt-1 text-body text-graphite">Vulnerabilities, packages and hosts across the fleet.</p>
          </div>
        </div>

        <div className="mt-10">
          <h1 className="text-title text-ink">Sign in</h1>
          <p className="mt-1 text-body text-graphite">Use your company Google account.</p>

          {failed ? (
            <div role="alert" className="mt-5 px-3 py-2.5 rounded-control border border-crit/40 bg-crit-tint">
              <p className="text-body font-semibold text-crit">The sign-in link could not be loaded</p>
              <p className="mt-1 text-small text-ink">The server did not answer with a Google sign-in address. Try again in a moment.</p>
              <Button className="mt-3" onClick={() => setAttempt((n) => n + 1)}>Try again</Button>
            </div>
          ) : (
            <Button
              variant="primary"
              className="mt-5"
              disabled={loading}
              onClick={() => {
                window.location.href = oauthUrl;
              }}
            >
              {loading && <Spinner />}
              {loading ? 'Preparing sign-in…' : 'Sign in with Google'}
            </Button>
          )}
        </div>
      </div>
    </main>
  );
};

export default OAuthPage;
